import { Button } from "@material-ui/core"
import RefreshIcon from "@material-ui/icons/Refresh"

// Atualização MANUAL da lista (endpoint allday). O refresh automático periódico
// foi removido: a lista se mantém em tempo real via SSE (eventos PLACED/STATUS) +
// drain de eventos. O allday agora só é chamado sob demanda, ao clicar aqui.
// (O status da loja iFood continua sendo consultado à parte, no efeito próprio.)
//
// O 2º argumento (forcar=true) faz o backend reconstruir cada pedido ignorando o
// cache do DTO — é a saída manual para um pedido que ficou preso no cache com
// status transitório (99/77). Só o clique manual força; o automático usa o cache.
export default function Segundos({ atualizar }) {
    return (
        <Button onClick={() => atualizar(true, true)} startIcon={<RefreshIcon fontSize="large" />}>
            Atualizar
        </Button>
    )
}
